export default {
  "product": {
    "product:autoMachineLearning": "Auto Machine Learning Platform",
    "product:modelDeployment": "AILM: Model Deployment",
    "product:anomalyDetection": "Anomaly Detection",
    "product:knowledgeManagement": "AILM: Knowledge Management",
    "product:adminService": "Admin Service",
    "product:onlineDeployment": "Online Deployment"
  },
  common: {
    profetAI: 'ProfetAI Inc.',
    welcome: 'ユーザー登録',
    username: 'ユーザー名',
    onlineUsers: 'オンライン ユーザー',
    password: 'パスワード',
    login: 'ログイン',
    submit: '提出',
    resetPassword: 'パスワードをリセットしてください。',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワードを確認してください。',
    changeSucceeded: '変更が成功しました。再度ログインしてください。',
  }, // common
  validate: {
    isRequired: '{0} は空白にできません。',
    notEqual: 'パスワードが一致しません。パスワードが同じであることを確認してください。',
    passValid: 'パスワードは、少なくとも1つの英小文字[a-z]、1つの英大文字[A-Z]、1つの数字[0-9]を含み、合計で少なくとも10文字である必要があります。',
  }, // validate
  warning: {
    networkErr: '網路環境がスムーズかどうかを確認してください。',
  }, // warning
  serviceQuotaNotEnough: 'ユーザーアカウントの認可された利用可能額が不足しています。システム管理者に連絡してください。',
  cannotConnectLicenseServer: '認可サーバーに接続できません。関連するネットワーク設定を確認してください。',
  dbWrong: 'データベースの異常',
  WrongUserNameOrPassword: "正しいユーザーアカウントとパスワードを入力してください。",
  AccountIsDisabled: "{0} このユーザーアカウントは無効になっています。システム管理者に連絡してください。",
  RequiredPasswordChange: "新しいパスワードを設定してください。",
  RequireAccountAndPassword: "ユーザーアカウントとパスワードの両方を入力してください。",
  NeedAdminRole: "システム管理者に連絡してください。",
  userNotFound: "このユーザーアカウントが見つかりません。",
  UnableToFindLicenseServer: "認可サーバーの場所が見つかりません。",
  UnableToFindTargetAccountService: "ユーザーアカウントまたは対象サービスが見つかりません。",
  PasswordExpired: "パスワードの有効期限が切れています。パスワードを再設定してください。",
}